import type { CityInfo } from '@/shared/api/experience';
import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';

export const useExcursionSoguStore = defineStore('excursion-sogu', () => {
  const filterStore = useExcursionFiltersStore();

  const geoObject = ref<CityInfo>({});
  const rubricId = ref<number | null>(null);

  const setGeoObject = (geo: MaybeRefOrGetter<CityInfo>) => {
    geoObject.value = toValue(geo);
  };

  const totalExperiences = computed(() => {
    if ('excursions_count' in geoObject.value) {
      return geoObject.value.excursions_count || 0;
    }
  });

  const filteredExperiences = computed(() => {
    return filterStore.searchTotalCount || 0;
  });

  return {
    rubricId,
    setGeoObject,
    totalExperiences,
    filteredExperiences,
  };
});
